import { useSelector } from 'react-redux';
import { selectGeneralInfoAddressSoleTrader } from '~/store/identification-form/selectors.ts';
import { useMemo } from 'react';
import { USA_CODE } from '~/constants/common.ts';

export const useUSACountryFlags = () => {
  const { citizenshipCountry, permanentAddress, birthplaceCountry } = useSelector(
    selectGeneralInfoAddressSoleTrader
  );

  return useMemo(() => {
    const citizenshipCountryUSA = citizenshipCountry?.value === USA_CODE;
    const permanentAddressUSA = permanentAddress?.country?.value === USA_CODE;
    const birthplaceCountryUSA = birthplaceCountry?.value === USA_CODE;

    return { citizenshipCountryUSA, permanentAddressUSA, birthplaceCountryUSA };
  }, [citizenshipCountry?.value, permanentAddress?.country?.value, birthplaceCountry?.value]);
};
